/*
  Uruchamia wideo w karcie produktu, gdy kursor wjeżdża na kartę, i zatrzymuje
  je po zjechaniu. Wideo ma preload="none", więc plik pobiera się dopiero przy
  pierwszym najechaniu — siatka kolekcji nie ciągnie ich wszystkich z góry.
*/
(function () {
  if (!window.matchMedia('(hover: hover)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function kartaZ(element) {
    return element instanceof Element ? element.closest('.card-wrapper') : null;
  }

  function wideoW(karta) {
    return karta ? karta.querySelector('video.karta-wideo') : null;
  }

  document.addEventListener('pointerover', function (zdarzenie) {
    if (zdarzenie.pointerType === 'touch') return;
    var karta = kartaZ(zdarzenie.target);
    // Ruch wewnątrz tej samej karty nie jest wjazdem na nią.
    if (!karta || kartaZ(zdarzenie.relatedTarget) === karta) return;
    var wideo = wideoW(karta);
    if (!wideo) return;
    wideo.muted = true;
    wideo.currentTime = 0;
    var obietnica = wideo.play();
    if (obietnica && obietnica.catch) obietnica.catch(function () {});
  });

  document.addEventListener('pointerout', function (zdarzenie) {
    if (zdarzenie.pointerType === 'touch') return;
    var karta = kartaZ(zdarzenie.target);
    if (!karta || kartaZ(zdarzenie.relatedTarget) === karta) return;
    var wideo = wideoW(karta);
    if (!wideo) return;
    wideo.pause();
    wideo.currentTime = 0;
  });
})();
